'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter } from 'next/navigation';
import { useCallback } from 'react';
export function useClearVideoQueryParams() {
  const $ = _c(3);
  const pathname = usePathname();
  const router = useRouter();
  let t0;
  if ($[0] !== pathname || $[1] !== router) {
    t0 = () => {
      const params = new URLSearchParams(window.location.search);
      if (!params.get("videoGuid") && !params.get("slug")) {
        return;
      }
      params.delete("videoGuid");
      params.delete("slug");
      const query = params.toString();
      const nextUrl = `${pathname}${query ? `?${query}` : ""}`;
      window.history.replaceState(null, "", nextUrl);
      router.replace(nextUrl, {
        scroll: false
      });
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}